function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import Box from './Box';
const Tooltip = /*#__PURE__*/React.memo(_ref => {
  let {
    cursor = 'help',
    effect = 'solid',
    event = 'click focus',
    tooltip,
    ...props
  } = _ref;
  const id = `tooltip-${Math.round(Math.random() * 99999999)}`;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, _extends({
    "data-for": id,
    "data-tip": tooltip,
    "data-effect": effect,
    event: event,
    __css: {
      display: 'inline-block',
      cursor
    }
  }, props)), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: id,
    globalEventOff: "click",
    multiline: true
  }));
});
Tooltip.propTypes = {
  dataEvent: PropTypes.string,
  tooltip: PropTypes.string.isRequired
};
Tooltip.displayName = 'Tooltip';
export default Tooltip;